module.exports = __webpack_public_path__ + "img/premium.c1fbb859.svg";